export const toISODate = (date: Date): string => {
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const isWeekend = (date: Date): boolean => {
  const day = date.getDay();
  return day === 0 || day === 6;
};

const buildHolidaySet = (holidays: string[]): Set<string> => {
  return new Set(
    holidays
      .map((holiday) => holiday.trim())
      .filter(Boolean)
  );
};

export const isWorkingDay = (
  date: Date,
  includeWeekends: boolean,
  holidaySet: Set<string>
): boolean => {
  if (!includeWeekends && isWeekend(date)) {
    return false;
  }

  const key = toISODate(date);
  return !holidaySet.has(key);
};

export const addWorkingDays = (
  startDate: Date,
  offset: number,
  includeWeekends: boolean,
  holidays: string[]
): Date => {
  const result = new Date(startDate);
  if (offset <= 0) {
    return result;
  }

  const holidaySet = buildHolidaySet(holidays);
  let remaining = offset;

  while (remaining > 0) {
    result.setDate(result.getDate() + 1);
    if (isWorkingDay(result, includeWeekends, holidaySet)) {
      remaining--;
    }
  }

  return result;
};
